var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.739,
    height: 19.91,
    viewBox: "0 0 20.739 19.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(-10 -29.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M186.632,33.365l8.269-2.256-.438-.887a1.165,1.165,0,0,0-1.56-.527l-7.4,3.67Z",
    transform: "translate(-171.786 0)",
    fill: "#375dbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M372.582,105.1a1.179,1.179,0,0,0-.307.042l-1.943.531-5.932,1.619h9.67l-.366-1.331A1.162,1.162,0,0,0,372.582,105.1Z",
    transform: "translate(-346.899 -73.927)",
    fill: "#375dbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M28.382,247.2H11.166a1.165,1.165,0,0,0-1.124.859,1.217,1.217,0,0,0-.042.3V261.34a1.165,1.165,0,0,0,1.164,1.164H28.38a1.165,1.165,0,0,0,1.164-1.164v-3.249h-6.91a1.98,1.98,0,0,1-1.979-1.979V253.52a1.978,1.978,0,0,1,1.742-1.962,2.149,2.149,0,0,1,.235-.015h6.915v-3.179A1.165,1.165,0,0,0,28.382,247.2Z",
    transform: "translate(0 -213.02)",
    fill: "#375dbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M560.794,491a1.137,1.137,0,0,0-.409-.241,1.173,1.173,0,0,0-.377-.063h-6.944a1.165,1.165,0,0,0-1.164,1.164v2.595a1.165,1.165,0,0,0,1.164,1.164h6.942a1.163,1.163,0,0,0,.377-.063,1.136,1.136,0,0,0,.408-.241,1.158,1.158,0,0,0,.379-.859v-2.595A1.149,1.149,0,0,0,560.794,491Zm-5.3,2.387a.582.582,0,0,1-.582.582h-.387a.582.582,0,0,1-.582-.582V493a.574.574,0,0,1,.224-.457.591.591,0,0,1,.358-.125h.385a.582.582,0,0,1,.582.582v.387Z",
    transform: "translate(-530.431 -451.366)",
    fill: "#375dbc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e4b25ce26bf940b817022022f20c897f.svg";
export { ForwardRef as ReactComponent };